<template>
  <modelframe>
    <div class="acountSet">
      <el-form :model="userData" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="userData.password" autocomplete="off"></el-input>
        </el-form-item><!--
        <el-form-item label="手机号码" prop="checkPassword">
          <el-input  v-model.number="userData.telePhone" autocomplete="off"></el-input>
        </el-form-item>-->
        <el-form-item label="验证码" prop="checkPassword" >
          <el-input class="check-code-input" v-model.number="userData.code" autocomplete="off"></el-input>
          <el-button class="check-code-btn" size="medium"  @click="getCode">获取验证码</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     @click="submitForm('userData')">
                     注销</el-button>
          <dialog-component is-show="Visiable" ref="dialog"
                            :password="userData.password"
                            :telePhone="userData.telePhone"
                            :code="userData.code"></dialog-component>
        </el-form-item>
      </el-form>
    </div>
  </modelframe>
</template>

<script>
import dialogComponent from "@/components/dialogComponent";
import {mapMutations, mapState} from "vuex";
export default {
  name: "modifyPassword",
  components:{
    dialogComponent
  },
  props:['isshow'],
  data(){
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else {
        callback();
      }
    };
    return {
      userData: {
        password:'',
        code: '',
      },
      trial:'1',
      Visiable:false,
      rules: {
        password: [
          { validator: validatePass, trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
      }
    }
  },
  methods:{

    submitForm() {
      this.$refs.ruleForm.validate(async (valid) =>{
        if (valid){
          this.Visiable=true
          //校验验证码
          const result=await this.$api.checkCheckCode(localStorage.getItem('username'),this.userData.code)
          console.log('校验验证码返回结果...',result)
          if (result){
            this.$nextTick(()=>{
              this.$refs.dialog.handleClose();
            })
          }else {
            this.$message.error('验证码输入错误')
          }
        }else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    getCode(){
      this.$api.getCheckCode(localStorage.getItem('username'),null).then(response=>{
        console.log('获取验证码成功',response)
      },error=>{
        console.log('获取验证码失败',error.message)
      });
    }
  },
}
</script>

<style scoped>
.acountSet{
  position: relative;
  margin:auto;
  top: 30px;
  text-align: center  ;
  vertical-align: center;
  width: 400px;
  height:fit-content;
  padding-bottom: 35px;
}
.check-code-btn{
  display:inline-block;
  position: absolute;
  top: 2px;
  padding-left:9px;
  width:90px;
  left:130px;
}
.check-code-input{
  display:flex;
  justify-self:left;
  width:100px;
}
</style>
